import { useTranslation } from 'react-i18next';
import { ClTabs, ManagementToolsTabs, Session } from 'enums/project.enum';
import { TabsProps } from 'antd';
import { useState, useEffect, useCallback } from 'react';

const useCdgTabs = (session: Session) => {
  const { t } = useTranslation();
  const [showOrdersTab, setShowOrdersTab] = useState(false);

  const getDefaultTab = () => {
    if (session === Session.CDG) {
      return ManagementToolsTabs.REFRESH_HR_COSTS;
    }
    if (session === Session.CL) {
      return ClTabs.PROGRESS_DATA;
    }
    return ManagementToolsTabs.SENDING_PROGRESS_DATA;
  };

  const [selectedTab, setSelectedTab] = useState<string>(getDefaultTab());

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setShowOrdersTab((prev) => !prev);
      }
    },
    []
  );

  useEffect(() => {
    if (session === Session.CL) {
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [session, handleKeyDown]);

  const cdgTabs: TabsProps['items'] =
    session === Session.CDG
      ? [
          // {
          //   key: ManagementToolsTabs.SENDING_PROGRESS_DATA,
          //   label: t('common.closing-data'),
          // },
          { key: ManagementToolsTabs.REFRESH_HR_COSTS, label: t('common.refresh-hr-costs') },
        ]
      : session === Session.CL
        ? [
            { key: ClTabs.PROGRESS_DATA, label: t('common.closing-data') },
            ...(showOrdersTab ? [{ key: ClTabs.ORDERS, label: t('common.orders') }] : []),
          ]
        : [];

  const onChangeTab = (key: string) => {
    setSelectedTab(key);
  };

  return { selectedTab, cdgTabs, onChangeTab };
};

export default useCdgTabs;
